LoadMore = (function ($) {
    $("._JsOpenInNewWindow").on("click", function (e) {
        e.preventDefault();
        var href = $(this).attr("href");
        window.open(href, "", "width=720,height=500,resizable,scrollbars=no,status=1");
    });
}(jQuery));